<template>
  <div class="training_table">
    <div class="padding">
      <div class="return_box">
        <el-button @click="back">返回</el-button>
        <p>
          创建操作考核>{{ $route.query.type == 0 ? "新增" : "编辑" }}操作考核
        </p>
      </div>
      <Bar :barList="barList" :active="active" />
    </div>
    <!-- 主体部分 -->
    <main>
      <div class="main_view">
        <keep-alive>
          <one
            v-if="
              (active == 0 && $route.query.type == 0) ||
              (active == 0 && state == 1) ||
              (active == 0 && $route.query.type == 2 && state == 1)
            "
            ref="one"
            :editorObj="editorObj"
          />
          <!-- <Two v-if="active == 1" ref="two" /> -->
          <Candidate
            v-if="active == 1"
            ref="two"
            :editData="typeState == 1 ? list_vip : 'null'"
          />
          <Three v-if="active == 2" ref="three" />
        </keep-alive>
      </div>
      <div class="button_view" :class="active == 0 ? '' : 'fixed'">
        <el-button @click="backType(0)">{{
          active == 0 ? "返回" : "上一步"
        }}</el-button>
        <el-button @click="backType(1)" :loading="sundflag">{{
          active == 2 ? "完成设置" : "下一步"
        }}</el-button>
      </div>
    </main>
  </div>
</template>

<script>
import Bar from "@/components/progress/Bar.vue";
import One from "./One.vue";
import Two from "./Two.vue";
import Three from "./Three.vue";
import assessApi from "@/api/assessment";
import Candidate from "@/components/progress/Candidate.vue";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      barList: [
        {
          id: "0",
          lable: "操作考核设置",
        },
        {
          id: "1",
          lable: "考核学员设置",
        },
        {
          id: "2",
          lable: "监考员员设置",
        },
      ],
      active: 0, // 用于控制第几步进度
      state: 0, // 编辑确保拿到数据
      parameter: {}, // 传参
      editorObj: {}, // 编辑详情
      sundflag: false, // 防抖
      hid: "",
      list_vip: [],
      getData: [],
      typeState: "", // 是否编辑状态 0新增 1为编辑
    };
  },
  methods: {
    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/releaseCheck", //跳转的路径
      });
      this.$destroy();
    },
    backType(type) {
      if (type == 0 && this.active == 0) {
        this.back();
      } else if (type == 1 && this.active == 2) {
        // 提交
        this.threeCachedata();
      } else if (type == 1 && this.active == 0) {
        // 保存组件一数据
        this.timeWith();
        this.getEditorArr(); // 第二步编辑考生
      } else if (type == 1 && this.active == 1) {
        // 保存组件二数据
        this.towintercept();
      } else if (type == 0) {
        this.active--;
      } else if (type == 1) {
        this.active++;
      }
    },
    // 缓存组件一
    timeWith() {
      this.$refs.one.submitForm(); // 正则校验
      this.parameter = this.$refs.one.operationForm;
    },
    // 缓存组件二数据
    towintercept() {
      let newarr = this.$refs.two.getData.map((item) => {
        return item.UserID;
      });
      if (newarr.length == 0) {
        this.$message({
          message: "警告，当前未勾选考生请选择",
          type: "warning",
        });
      } else {
        this.parameter.addStudent = JSON.stringify(newarr);
        this.active = 2;
      }
    },
    // 缓存组件三数据
    async threeCachedata() {
      let newArr = this.$refs.three.list_vip.map((item) => {
        return item.UserID;
      });
      if (newArr.length == 0) {
        this.$message({
          message: "警告，当前未勾选监考人员请选择",
          type: "warning",
        });
      } else {
        this.parameter.addTeacher = JSON.stringify(newArr);
        if (this.$route.query.type == 0 || this.$route.query.type == 2) {
          // 新增提交
          let text = this.$route.query.type == 0 ? "新增" : "补考";
          this.sundflag = true;
          this.parameter.guid = JSON.parse(loginvuex.state.userlist).guid
          this.parameter.userID = JSON.parse(loginvuex.state.userlist).userID
          const { data } = await assessApi.addOperation(this.parameter);
          if (data.Status == 200) {
            this.$router.push({
              path: "/releaseCheck", //跳转的路径
            });
            this.$message({
              message: `恭喜你，${text}考核名为${this.parameter.title}成功`,
              type: "success",
            });
            setTimeout(() => {
              this.sundflag = false;
            }, 500);
          } else {
            this.$message.error(data.Msg);
            this.sundflag = false;
          }
        } else if (this.$route.query.type == 1) {
          // 编辑
          this.parameter.examineID = this.$route.query.ID; // 编辑传ID
          this.parameter.student = this.parameter.addStudent; //考生
          this.parameter.teacher = this.parameter.addTeacher; // 监考员
            this.parameter.guid = JSON.parse(loginvuex.state.userlist).guid
          this.parameter.userID = JSON.parse(loginvuex.state.userlist).userID
          this.sundflag = true;
          const { data } = await assessApi.deitOperation(this.parameter);
          if (data.Status == 200) {
            this.$router.push({
              path: "/releaseCheck", //跳转的路径
            });
            this.$message({
              message: `恭喜你，编辑培训名为${this.parameter.title}成功`,
              type: "success",
            });
            setTimeout(() => {
              this.sundflag = false;
            }, 500);
          } else {
            this.$message.error(data.Msg);
            this.sundflag = false;
          }
        }
      }
    },
    // 编辑回显  复制试卷回显
    async editorEcho() {
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        let parameter = {
           guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
          examineID: this.$route.query.ID,
        };
        const { data } = await assessApi.getDetails(parameter);
        if (data.Status == 200) {
          this.editorObj = data.Data[0];
          this.state = 1;
        } else {
          this.$message.error(data.Msg);
        }
      }
    },
    // 获取编辑数组
    async getEditorArr() {
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        let obj = {
          userType: "student", // teacher监考人员 student 考生
          examineID: this.$route.query.ID,
           guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        };
        const { data } = await assessApi.getDetailsArr(obj);
        if (data.Status == 200) {
          this.list_vip = data.Data.map((item) => {
            item.Birthday1 = this.$moment(item.BeginTime).format(
              "YYYY/MM/DD HH:mm"
            );
            return item;
          });
          this.getData = JSON.parse(JSON.stringify(this.list_vip));
        } else {
          this.$message.error(data.Msg);
        }
      }
    },
  },
  components: {
    Bar,
    One,
    // Two,
    Three,
    Candidate,
  },
  created() {
    this.editorEcho();
    this.typeState = this.$route.query.type; // 编辑状态
    this.hid = JSON.parse(loginvuex.state.userlist).hid;
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  min-height: 740px;
  background: #fff;
  border-radius: 0px 0px 4px 4px;
}
.padding {
  padding: 30px 36px 0px 36px;
  // margin-bottom: 30px;
}
.return_box {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  .el-button {
    // width: 56px;
    height: 40px;
    background: #f6f6f6;
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    margin-right: 30px;
  }
}
main {
  display: flex;
  flex-direction: column;
  min-height: 580px;
  position: relative;
  .main_view {
    flex: 1;
    margin: 30px 36px 0px 36px;
  }
  .button_view {
    // width: 100%;
    flex: 0 0 110px;
    border-top: 1px solid #eeeef0;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 112px;
      height: 40px;
      background: #ebecf1;
      border-radius: 3px;
      &:nth-child(1) {
        margin-right: 20px;
      }
    }
  }
}
.fixed {
  position: fixed;
  left: 50%;
  bottom: 5%;
  transform: translate(-5%, -5%);
  border-top: none !important;
}
</style>
